import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { titleCase } from "../../../util/constants";

const useStyles = makeStyles((theme) => ({
  select: {
    height: 36,
    width: 150,
    border: "1px solid #006E7D",
    borderRadius: "18px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: "bold",
    fontSize: "13px",
    "&:before": {
      borderColor: "transparent",
    },
    "&:after": {
      borderColor: "transparent",
    },
    "&:hover:before": {
      borderColor: "transparent",
      display: "none",
    },
  },
  formControl: {
    marginTop: -15,
  },
}));

const style = {
  position: "absolute",
  top: 4,
  right: 12,
  pointerEvents: "none",
  height: 25,
};

const icon = () => {
  return (
    <svg
      id="dropdown_arrow"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        id="Path_41103"
        data-name="Path 41103"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Union_1"
        data-name="Union 1"
        d="M10,0,5.014,4.986ZM0,0,4.987,4.986Z"
        transform="translate(7.4 9.786)"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </svg>
  );
};

export const Dropdown = ({
  value,
  onChange,
  required = false,
  disabled = false,
  list,
  label,
  error,
  name,
  errorMessage = false,
  countryList = undefined,
}) => {
  const classes = useStyles();

  return (
    <FormControl error={error} className={classes.formControl}>
      <InputLabel
        style={{ marginTop: value === "" ? -8 : 0 }}
        id="demo-simple-select-outlined-label"
        value
      >
        {label}
      </InputLabel>

      <Select
        disabled={disabled}
        required={required}
        style={{
          height: 36,
          textAlign: "left",
          paddingLeft: "20px",
          paddingTop: "4px",
        }}
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
        value={value}
        onChange={onChange(name)}
        label={label}
        IconComponent={icon}
        className={classes.select}
      >
        {countryList
          ? countryList.map(({ id: itemValue, nicename: menuLabel }) => (
              <MenuItem key="itemValue" value={itemValue}>
                {titleCase(menuLabel)}
              </MenuItem>
            ))
          : list.map(({ value: itemValue, label: menuLabel }) => (
              <MenuItem key="itemValue" value={itemValue}>
                {titleCase(menuLabel)}
              </MenuItem>
            ))}
      </Select>
      <span style={{ fontSize: "0.65vw", paddingLeft: 10, color: "red" }}>
        {errorMessage}
      </span>
    </FormControl>
  );
};
